var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapFumetto"},[(_vm.isVisible)?_c('div',{staticClass:"slds-popover_tooltip slds-nubbin_right-top slds-popover__body slds-slide-from-bottom-to-top slds-slide-from-left-to-right box fumetto",attrs:{"role":"tooltip","id":"{action.id}"}},[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }